module.exports = __webpack_public_path__ + "img/male.0f0490ec.svg";